import Marker from '../Marker';

interface HeroMarkersProps {
  cashOfferMarkerImage: string;
  newOfferMarkerImage: string;
  highestOfferMarkerImage: string;
}

const HeroMarkers = ({
  cashOfferMarkerImage,
  newOfferMarkerImage,
  highestOfferMarkerImage,
}: HeroMarkersProps) => {
  return (
    <>
      <Marker
        imageSource={cashOfferMarkerImage}
        lazy={false}
        className="left-[57%] top-[40%] h-15 w-39 opacity-0 animate-marker-fade-in [animation-delay:0.5s] md:left-[60%] lg:left-[50%] lg:top-[25%] lg:h-20 lg:w-50"
      />
      <Marker
        imageSource={newOfferMarkerImage}
        lazy={false}
        className="right-[55%] top-[45%] h-15 w-39 opacity-0 animate-marker-fade-in [animation-delay:1.5s] md:right-[52%] md:top-[43%] lg:right-[57%] lg:top-[30%] lg:h-20 lg:w-50"
      />
      <Marker
        imageSource={highestOfferMarkerImage}
        lazy={false}
        className="right-[35%] top-[20%] h-15 w-39 opacity-0 animate-marker-fade-in [animation-delay:2.5s] md:right-[40%] md:top-[22%] lg:right-[36%] lg:top-[7%] lg:h-20 lg:w-50"
      />
    </>
  );
};

export default HeroMarkers;
